export enum SpoilerCreationMode {
  Movie,
  Episode
}
